import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import Branch from 'utils/branch';
import MediaQuery, { matchMedia, breakpoints } from 'utils/media-query';
import styles from './styles.scss';

const trackClickEvent = (props) => {
  trackV2({
    ...props,
    action: 'click'
  });
};

class FooterUpsell extends React.Component {
  componentDidMount() {
    const data = {
      channel: 'web',
      feature: 'athlete footer upsell'
    };

    if (matchMedia.screenSm()) {
      Branch.createLink('.footer-download-btn', data);
    }
  }

  render() {
    const { authUrls, analyticsData } = this.props;
    return (
      <div className={styles.container}>
        <h3>{I18n.t('strava.athletes.show_public.bottom_cta_header')}</h3>

        <MediaQuery maxWidth={breakpoints.screenSm}>
          <a
            href="/mobile"
            className={`btn btn-primary footer-download-btn ${styles.btn}`}
            onClick={() =>
              trackClickEvent({ ...analyticsData, element: 'download_button' })
            }
          >
            {I18n.t('strava.athletes.show_public.get_the_app_cta')}
          </a>
        </MediaQuery>

        <MediaQuery minWidth={breakpoints.screenSm}>
          <a
            href={authUrls.facebook}
            className={`btn btn-facebook ${styles.btnFacebook} ${styles.btn}`}
            onClick={() =>
              trackClickEvent({ ...analyticsData, element: 'facebook_button' })
            }
          >
            {I18n.t('strava.athletes.show_public.facebook_cta')}
          </a>

          <a
            href={authUrls.google}
            className={`btn btn-default ${styles.btnGoogle} ${styles.btn}`}
            onClick={() =>
              trackClickEvent({ ...analyticsData, element: 'google_button' })
            }
          >
            {I18n.t('strava.athletes.show_public.google_cta')}
          </a>

          <a
            href={authUrls.email}
            className={`btn btn-primary ${styles.btnEmail} ${styles.btn}`}
            onClick={() =>
              trackClickEvent({ ...analyticsData, element: 'email_button' })
            }
          >
            {I18n.t('strava.athletes.show_public.email_cta')}
          </a>
        </MediaQuery>
      </div>
    );
  }
}

FooterUpsell.propTypes = {
  authUrls: PropTypes.shape({
    facebook: PropTypes.string.isRequired,
    google: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired
  }).isRequired,
  analyticsData: PropTypes.shape().isRequired
};

export default FooterUpsell;
